/**
 * Companies Page (KYB)
 *
 * Know Your Business verification for corporate entities.
 */

import React from 'react';
import { CompaniesPage as CompaniesPageComponent } from '../companies';

export default function CompaniesPage() {
  return <CompaniesPageComponent />;
}
